import { jsx as _jsx } from "react/jsx-runtime";
import hotelImage from 'assets/icons/Header/SubheaderHotelier/image-hilton.jpg';
import scss from './HotelImage.module.scss';
export const HotelImage = () => (_jsx("div", Object.assign({ className: scss.hotelImageThumb }, { children: _jsx("img", { src: hotelImage, className: scss.hotelImage, alt: "hotel" }) })));
